/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { ConnectedFocusError } from 'focus-formik-error';
import { Formik, Form } from 'formik';
import React from 'react';

const C7Form = (props) => {
  const {
    children,
    validate,
    initialValues,
    onSubmit,
    validateOnBlur = false,
    className,
    id,
    formProps = {},
    ...rest
  } = props;

  return (
    <Formik
      validate={validate}
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnBlur={validateOnBlur}
      enableReinitialize
      {...rest}
    >
      <Form className={classNames('c7-form', className)} {...formProps} id={id}>
        <ConnectedFocusError />
        {children}
      </Form>
    </Formik>
  );
};

export default C7Form;
